exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-78f838b1]{height:20px;background:#f5f5f5}", ""]);

// exports
